import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface MetaTagsProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
}

const defaultMeta = {
  title: 'Cryptfluencers - NFT Collection',
  description: 'Mint your unique Cryptfluencer NFT on Base, PulseChain, or Chia. Join the community of digital influencers in the crypto space.',
  image: '/og-image.jpg', // You'll need to add this image to your public folder
  url: 'https://cryptfluencers.xyz' // Replace with your actual domain
};

export function MetaTags({ 
  title = defaultMeta.title,
  description = defaultMeta.description,
  image = defaultMeta.image,
  url = defaultMeta.url 
}: MetaTagsProps) {
  const location = useLocation();
  const currentUrl = `${url}${location.pathname}`;

  useEffect(() => {
    // Update standard meta tags
    document.title = title;
    document.querySelector('meta[name="description"]')?.setAttribute('content', description);

    // Update Open Graph meta tags
    document.querySelector('meta[property="og:title"]')?.setAttribute('content', title);
    document.querySelector('meta[property="og:description"]')?.setAttribute('content', description);
    document.querySelector('meta[property="og:image"]')?.setAttribute('content', image);
    document.querySelector('meta[property="og:url"]')?.setAttribute('content', currentUrl);

    // Update Twitter Card meta tags
    document.querySelector('meta[name="twitter:title"]')?.setAttribute('content', title);
    document.querySelector('meta[name="twitter:description"]')?.setAttribute('content', description);
    document.querySelector('meta[name="twitter:image"]')?.setAttribute('content', image);
    document.querySelector('meta[name="twitter:card"]')?.setAttribute('content', 'summary_large_image');
  }, [title, description, image, currentUrl]);

  return null;
} 